import { Spinner, type SpinnerProps } from '@chakra-ui/react';

export type UiSpinnerProps = SpinnerProps;

export const UiSpinner = Spinner;
